import React, {useContext} from 'react';
import type {NextRouter} from 'next/router';

const RouterContext = React.createContext<NextRouter | null>(null);

/**
 * Кладёт роутер приложения в контекст.
 *
 * Нужен, потому что Apollo при SSR рендерит дерево сам (getDataFromTree), вне контекста Next,
 * и `useRouter()` из next/router там падает с «NextRouter was not mounted».
 * В _app роутер приходит пропсом, поэтому берём его оттуда — и на сервере, и в браузере.
 */
export const RouterProvider: React.FC<{router: NextRouter; children: React.ReactNode}> = ({router, children}) => (
	<RouterContext.Provider value={router}>{children}</RouterContext.Provider>
);

/** Роутер приложения; null, если компонент отрисован вне провайдера */
export function useAppRouter(): NextRouter | null {
	return useContext(RouterContext);
}
